// Shared module-level variable — readable synchronously from any component
// without an async event round-trip.
let _playing = true;

export const setSharedPlaying = (val: boolean) => {
  _playing = val;
};
export const getSharedPlaying = () => _playing;
